import { DependencyError } from '@cumu/shared';
import { controller } from '@github/catalyst';
import { ClipboardCopyElement } from '@github/clipboard-copy-element';

@controller('copy-shortened-link')
export class CopyShortenedLinkElement extends ClipboardCopyElement {
  disconnected = new AbortController();

  connectedCallback(): void {
    super.connectedCallback();
    this.addEventListener(
      'click',
      async () => {
        if (this.value) {
          return;
        }
        const url = this.getAttribute('url');
        if (!url) {
          return;
        }
        this.classList.add('btn-busy');
        let response;
        try {
          response = await fetch(location.origin + '/go', {
            method: 'POST',
            body: JSON.stringify({ url })
          });
        } finally {
          this.classList.remove('btn-busy');
        }
        if (!response.ok) {
          throw new DependencyError(response, await response.text());
        }
        const data = await response.json();
        this.value = data.url;
        this.click();
      },
      { signal: this.disconnected.signal }
    );
  }

  disconnectedCallback(): void {
    this.disconnected.abort();
  }
}

declare global {
  interface Window {
    CopyShortenedLinkElement: typeof CopyShortenedLinkElement;
  }
  interface HTMLElementTagNameMap {
    'copy-shortened-link': CopyShortenedLinkElement;
  }
}
